import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { MakeEnquiry } from '../shared/interfaces/make-enquiry.interface'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class UtilityService {
    #httpClient = inject(HttpClient)

    makeEnquiry(request: MakeEnquiry): Observable<void> {
        return this.#httpClient.post<void>(`${environment.baseUrl}consumer-utilities/general-enquiry`, request)
    }
}
